export default __webpack_public_path__ + "static/media/frakt-pandas-compress.f6f841fd.webp";